import { axiosInstance } from '../shared/services/axios-instance'
import * as endpoints from '../constants/api-constants'

class GameServices {
  static getTop(gameId, config) {
    return axiosInstance
      .get(endpoints.getTop + '/' + gameId, config)
      .then(resp => resp.data)
  }

  static getTopPagination(gameId, size, page, config) {
    return axiosInstance
      .get(
        endpoints.getTop + '/' + gameId + '?size=' + size + '&page=' + page,
        config
      )
      .then(resp => resp.data)
  }

  static getTopPaginationMoreGames(payload) {
    return axiosInstance
      .post(endpoints.topMultiGame, payload)
      .then(resp => resp.data)
  }

  static getLife(gameId, config) {
    return axiosInstance
      .get(endpoints.getLife + '/' + gameId, config)
      .then(resp => resp.data)
  }

  static getUserRankingMultiGames(payload, config) {
    return axiosInstance
      .post(endpoints.userRankingMultiGames, payload, config)
      .then(resp => resp.data)
  }

  static getAcumulationConcourse(concourseId, config) {
    return axiosInstance
      .get(endpoints.getAcumulationConcourse + '/' + concourseId, config)
      .then(resp => resp.data)
  }

  static postLife(gameId, payload, config) {
    return axiosInstance
      .post(endpoints.getLife + '/' + gameId, payload, config)
      .then(resp => resp.data)
  }

  static postPromotionalKey(payload, config) {
    return axiosInstance
      .post(endpoints.postPromotionalKey, payload, config)
      .then(resp => resp.data)
  }

  static getTokenGame(gameId, config) {
    return axiosInstance
      .get(endpoints.getTokenGame + '/' + gameId, config)
      .then(resp => resp.data)
  }

  static postGameParticipationRedeem(gameId, config) {
    return axiosInstance
      .post(endpoints.postGameParticipationRedeem + '/' + gameId, {}, config)
      .then(resp => resp.data)
  }

  static postGameParticipationSave(payload, config) {
    return axiosInstance
      .post(
        endpoints.postGameParticipationSave + '/' + payload.gameId,
        payload,
        config
      )
      .then(resp => resp.data)
  }

  static getLifeRemaining(gameId, config) {
    return axiosInstance
      .get(endpoints.getLifeRemaining + '/' + gameId, config)
      .then(resp => resp.data)
  }
  static consumeLife(gameId, totalLives, config) {
    return axiosInstance
      .post(endpoints.consumeLife + '/' + gameId, { totalLives }, config)
      .then(resp => resp.data)
  }
}

export default GameServices
